import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class DatatableDetailsViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const view = this.getView(route);
    if (view) {
      return this.routeGuardService.handleRoute(view, route);
    }
    return Promise.resolve(true);
  }

  getView(route?: ActivatedRouteSnapshot): View {
    const uuid = route?.paramMap?.get('uuid') || 'unknown';
    return {
      route: `datatables-editor/${uuid}`,
      iframeUrl: `texts-table-editor/${uuid}`,
    };
  }
}
